import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LangTranslate } from "../../types/types";


interface IAdminState {
  langTranslate: LangTranslate[];
  isSuperAdmin:Boolean;
}

const initialState: IAdminState = {
  langTranslate: [],
  isSuperAdmin:false
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    setListTranslate(state, action: PayloadAction<LangTranslate[]>) {
      state.langTranslate = action.payload;
    },
 updateListTranslate(state, action: PayloadAction<{ index: number; newTranslate: string }>) {
  const item=state.langTranslate[action.payload.index];
      if (item) {
        
    item.translate = action.payload.newTranslate;

  } else {
    // console.warn("Invalid index in updateListTranslate:", action.payload.index);
  }
 },
 setSuperAdmin(state,action:PayloadAction<{flag:Boolean}>){
  state.isSuperAdmin=action.payload.flag;
 }
 ,
 
},
});

export const { setListTranslate,updateListTranslate,setSuperAdmin} = adminSlice.actions;
export default adminSlice.reducer;
